import { lazy } from 'react';

export const ForgetPasswordLazy = lazy(() => import('./ForgetPassword'));
